/**
 * Demo modifier thumbnails extracted from `src/new_designs/wingstop-ecommerce 2.html`
 * into `public/wingstop-modifiers/*.jpg` (flavor grid reference).
 */

const BASE = '/wingstop-modifiers';

/** Slugs that exist under /public/wingstop-modifiers */
const KNOWN_SLUGS = new Set([
  'atomic',
  'mango-habanero',
  'cajun',
  'original-hot',
  'louisiana-rub',
  'mild',
  'bbq',
  'lemon-pepper',
  'garlic-parmesan',
  'hawaiian',
]);

export function normalizeModifierSlug(name) {
  return String(name || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

function parseApiImage(image) {
  if (!image) return null;
  if (String(image).includes('http')) return image;
  return `https://syspos.s3.me-central-1.amazonaws.com/media/${image}`;
}

/**
 * @param {{ name?: string, image?: string }} modifier
 * @returns {string|null} URL or null → use placeholder tile
 */
export function resolveModifierThumbUrl(modifier) {
  if (!modifier) return null;
  const fromApi = parseApiImage(modifier.image);
  if (fromApi) return fromApi;

  const slug = normalizeModifierSlug(modifier.name);
  if (KNOWN_SLUGS.has(slug)) return `${BASE}/${slug}.jpg`;

  const fuzzy = [...KNOWN_SLUGS].find((key) => slug && (slug.includes(key) || key.includes(slug)));
  if (fuzzy) return `${BASE}/${fuzzy}.jpg`;

  const compact = slug.replace(/-/g, '');
  const fuzzy2 = [...KNOWN_SLUGS].find((key) => compact && key.replace(/-/g, '').includes(compact));
  if (fuzzy2) return `${BASE}/${fuzzy2}.jpg`;

  return null;
}
